import React from 'react';
import { Form, Input, Button, Space, FormInstance } from 'antd';
import { StyleSearchParams } from '../types';

interface SearchFormProps {
  form: FormInstance<StyleSearchParams>;
  onSearch: () => void;
  onReset: () => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ form, onSearch, onReset }) => {
  return (
    <Form form={form} layout="inline" onFinish={onSearch}>
      <Form.Item name="styleName" label="风格名称">
        <Input placeholder="请输入风格名称" allowClear />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
          <Button onClick={onReset}>重置</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default SearchForm;

